module.exports = __webpack_public_path__ + "resources/game-info-dialog-content-icon.7e7941ddb5daece0.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/game-subscribe-dialog/img/game-info-dialog-content-icon.png
// module id = 925
// module chunks = 0